/*
  MEET THE TOOLS — tab rail behaviour.

  Delegated from the document rather than bound to the tabs, for the same reason
  assets/kit-comparison.js does it: <product-rerender> replaces parts of the buy column on a
  variant change, and a listener attached to a button that gets replaced goes with it. Nothing here
  holds a reference to an element between events.

  State lives in the DOM — aria-selected on the tab, [hidden] on the panel — so there is no cache to
  fall out of step with the markup Liquid rendered, and the server-rendered first tab is simply the
  starting point.
*/
(function () {
  var TAB = '.mtt__tab';
  var ROOT = '[data-mtt]';

  function tabsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll(TAB));
  }

  /*
    Selecting a tab is three things: the rail's fill, the roving tabindex, and which panel is
    hidden. All three are set from the same loop so they cannot disagree — a mismatch between
    aria-selected and [hidden] is the bug that makes a tab look chosen while showing another
    tool's photograph.

    tabindex is roving (0 on the selected tab, -1 on the rest) because a tablist is ONE tab stop:
    Tab enters the rail and the arrow keys move within it, rather than Tab walking through seven
    buttons.
  */
  function select(root, tab, focus) {
    var tabs = tabsOf(root);

    tabs.forEach(function (candidate) {
      var isTarget = candidate === tab;

      candidate.classList.toggle('is-active', isTarget);
      candidate.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      candidate.setAttribute('tabindex', isTarget ? '0' : '-1');

      var panel = document.getElementById(candidate.getAttribute('aria-controls'));

      if (panel) {
        if (isTarget) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', 'hidden');
        }
      }
    });

    /*
      Focus moves only for keyboard selection. Doing it on click would drag the page to the rail on
      a phone, where the rail is a horizontal scroller and the tap already landed where it meant to.
    */
    if (focus) {
      tab.focus();
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) {
      return;
    }

    var tab = event.target.closest(TAB);

    if (!tab) {
      return;
    }

    var root = tab.closest(ROOT);

    if (!root || tab.getAttribute('aria-selected') === 'true') {
      return;
    }

    select(root, tab, false);
  });

  /*
    Both axes are accepted. The rail is vertical on a desktop and horizontal on a phone, and the
    same seven buttons serve both, so binding only Up/Down would leave the arrow keys dead in the
    orientation the layout is actually in.

    The step wraps, which is what the tablist pattern expects: Down on the last tool returns to the
    first rather than doing nothing.
  */
  document.addEventListener('keydown', function (event) {
    if (!event.target || !event.target.closest) {
      return;
    }

    var tab = event.target.closest(TAB);

    if (!tab) {
      return;
    }

    var root = tab.closest(ROOT);

    if (!root) {
      return;
    }

    var tabs = tabsOf(root);
    var index = tabs.indexOf(tab);

    if (index === -1) {
      return;
    }

    var next = null;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        next = tabs[(index + 1) % tabs.length];
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        next = tabs[(index - 1 + tabs.length) % tabs.length];
        break;
      case 'Home':
        next = tabs[0];
        break;
      case 'End':
        next = tabs[tabs.length - 1];
        break;
      default:
        return;
    }

    /*
      preventDefault only once a key we handle has matched, so Tab, Enter, Space and every shortcut
      the browser owns are left alone. Without the early return above this would swallow them.
    */
    event.preventDefault();

    if (next) {
      select(root, next, true);
    }
  });
})();
